import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'age',
  standalone: false,
})
export class AgePipe implements PipeTransform {
  transform(birthday: Date): string {
    if (birthday && birthday < new Date()) {
      return new Number((new Date().getTime() - birthday.getTime()) / 31536000000).toFixed(0).toString() + ' ans';
    }
    return '';
  }
}
